export default {
  suggestions: {
    width: '250px',
    margin: '30px 0',
    right: '-20px',
    zIndex: 9999,
    list: {
      backgroundColor: '#1f1f1f',
      border: 'none',
      fontSize: 14,
      maxHeight: 400,
      overflowY: 'auto',
      padding: '4px',
      overflowX: 'hidden',
    },
    item: {
      padding: '5px 15px',
      borderBottom: 'none',
      '&focused': {
        backgroundColor: '#4e46b4',
      },
    },
  },
  highlighter: {
    height: '1px',
  },
};
